import produce from 'immer'
import {
  createConvoSidebarSectionAsync,
  deleteConvoSidebarSectionAsync,
  fetchSectionsAsync,
  fetchSectionsSubscriptionsAsync,
  toggleCreateConvoSectionModal,
  toggleEditConvoSectionModal,
  toggleRenameConvoSectionModal,
  toggleViewConvoSectionModal,
  updateConvoSidebarSectionAsync,
} from 'shared/store/actions/user/sections'
import {
  ConversationSidebarSectionConfig,
  SidebarSectionDetailModal,
} from 'shared/typings/conversationsSidebar/Filters'

import { createReducer } from 'typesafe-actions'

export const conversationSections = createReducer<Record<string, ConversationSidebarSectionConfig>>(
  {}
)
  .handleAction(fetchSectionsAsync.success, (state, action) => {
    const sections = action.payload
    return produce(state, (draft) => {
      sections.forEach((section: ConversationSidebarSectionConfig) => {
        draft[section.id] = section
      })
    })
  })
  .handleAction(
    [createConvoSidebarSectionAsync.success, updateConvoSidebarSectionAsync.success],
    (state, action) => {
      const section = action.payload.config
      return produce(state, (draft) => {
        draft[section.id] = section
      })
    }
  )
  .handleAction(deleteConvoSidebarSectionAsync.success, (state, action) => {
    const { id } = action.payload
    return produce(state, (draft) => {
      delete draft[id]
    })
  })

export const conversationSectionsStatus = createReducer<null | string>(null).handleAction(
  [
    fetchSectionsAsync.success,
    fetchSectionsAsync.request,
    fetchSectionsAsync.cancel,
    fetchSectionsAsync.failure,
  ],
  (_, action) => action.type
)

export const conversationSectionsSubscriptionsStatus = createReducer<null | string>(
  null
).handleAction(
  [
    fetchSectionsSubscriptionsAsync.success,
    fetchSectionsSubscriptionsAsync.request,
    fetchSectionsSubscriptionsAsync.cancel,
    fetchSectionsSubscriptionsAsync.failure,
  ],
  (_, action) => action.type
)

export const sidebarSectionDetailModal = createReducer<SidebarSectionDetailModal>({
  open: false,
  modalType: 'new',
})
  .handleAction(toggleRenameConvoSectionModal, (state, action) => ({
    open: !state.open,
    modalType: 'rename',
    ...action.payload,
  }))
  .handleAction(toggleCreateConvoSectionModal, (state) => ({
    open: !state.open,
    modalType: 'new',
  }))
  .handleAction(toggleViewConvoSectionModal, (state, action) => ({
    open: !state.open,
    modalType: 'view',
    uuid: action.payload,
  }))
  .handleAction(toggleEditConvoSectionModal, (state, action) => ({
    open: !state.open,
    modalType: 'edit',
    uuid: action.payload,
  }))
